import { Box, Button, Grid, IconButton, InputAdornment, Paper, Stack, TextField, Typography } from "@mui/material";
import { message } from "antd";
import { useState } from "react";
import { Key, Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import validator from "validator";

const EnterNewPassword = () => {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [messageApi, contextHolder] = message.useMessage();
    const [showPassword1, setShowPassword1] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    const [newPasswordError, setNewPasswordError] = useState({status: false, message: ""});
    const [confirmPasswordError, setConfirmPasswordError] = useState({status: false, message: ""});

    const navigate = useNavigate();
    const [sending, setSending] = useState(false);

    const validatePassword = (password) => {
      if(validator.isStrongPassword(newPassword, {
        minLength: 8,
        minSymbols: 1,
        minLowercase: 1,
        minUppercase: 1,
        minNumbers: 1,
      })) {
        setNewPasswordError({
          status: false,
          message: "",
        });
      } else {
        setNewPasswordError({
          status: true,
          message: "Not strong password!",
        });
      }
    }
    const matchPassword = (confirm_password) => {
      if(confirm_password === newPassword) {
        setConfirmPasswordError({
          status: false,
          message: "",
        });
      } else {
        setConfirmPasswordError({
          status: true,
          message: "Password not match!",
        });
      }
    }

    const handleInputChange = (e) => {
      if(e.target.name === 'newPassword') {
          setNewPassword(e.target.value);
          validatePassword(e.target.value);
      }
      else if(e.target.name === 'confirmPassword') {
        setConfirmPassword(e.target.value);
        matchPassword(e.target.value);
      }
        
    }

    const toggleShowPassword1 = () => {
      setShowPassword1(showPassword1 => !showPassword1);
    }
    const toggleShowPassword2 = () => {
      setShowPassword2(showPassword2 => !showPassword2);
    }

    const validate = () => {
      if (newPassword.length === 0 || confirmPassword.length === 0) {
        if(newPassword.length === 0) {
          setNewPasswordError({
            status: true,
            message: "This field can't be empty!",
          });
        } else {
          setNewPasswordError({
            status: false,
            message: "",
          });
        }
        if(confirmPassword.length === 0) {
          setConfirmPasswordError({
            status: true,
            message: "This field can't be empty!",
          });
        } else {
          setConfirmPasswordError({
            status: false,
            message: "",
          });
        }
        return false;
      }
      else {
          setNewPasswordError({
            status: false,
            message: "",
          });
          setConfirmPasswordError({
            status: false,
            message: "",
          });
          return true;
      }

    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(validate()) {
          const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/forgot-password/reset-password`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({newPassword: newPassword}),
        });
        const responseData = await response.json();

        if(response.status === 200) {
            messageApi.open({
                type: 'success',
                content: `${responseData.message}`,
                style: {
                  marginTop: '15vh',
                },
            });
            setTimeout(() => {
                navigate('/');
            }, 1000);
        } else if(response.status === 406) {
            messageApi.open({
                type: 'error',
                content: `${responseData.error_message}`,
                style: {
                  marginTop: '15vh',
                },
            });
        }
        }
    }

  return (
    <Box sx={{display: "flex" ,justifyContent: "center", padding: "50px", fontWeight: "500px"}}>
      {contextHolder}
      <Paper elevation={0} sx={{width: "400px", backgroundColor: "#ffff", margin: "100px"}}>
        <Grid className="form-title" container spacing={1} style={{marginTop: 5}}>
          <Grid item> <Typography variant="h5" sx={{textAlign: "center", fontWeight: "400", fontFamily: "Roboto Mono"}}>Enter New Password</Typography> </Grid>
          <Grid item> <Key sx={{width: 40, height: 40}}/> </Grid>
        </Grid>
        <form className="classes.root" autoComplete="off" onSubmit={handleSubmit}>
          <Stack spacing={3} sx={{margin: "30px"}}>
            <TextField
              variant="standard"
              name="newPassword"
              label="New Password"
              size="small"
              value={newPassword}
              onChange={handleInputChange}
              type={showPassword1 ? "text" : "password"}
              InputProps={{
                          endAdornment:
                            <InputAdornment position='end'>
                              <IconButton onClick={toggleShowPassword1}>
                                {showPassword1 ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          
                        }}
              {...(newPasswordError.status && {error: true, helperText: newPasswordError.message})}
            />
            <TextField
              variant="standard"
              name="confirmPassword"
              label="Confirm Password"
              size="small"
              value={confirmPassword}
              onChange={handleInputChange}
              type={showPassword2 ? "text" : "password"}
              InputProps={{
                          endAdornment:
                            <InputAdornment position='end'>
                              <IconButton onClick={toggleShowPassword2}>
                                {showPassword2 ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          
                        }}
              {...(confirmPasswordError.status && {error: true, helperText: confirmPasswordError.message})}
            />
            <Grid container className="form-input-row">
              <Grid item>
               <Button variant="contained" color="success" size="medium" disableElevation type="submit">Save</Button>
              </Grid>
            </Grid>
            </Stack>
        </form>
      </Paper>
    </Box>
  )
}

export default EnterNewPassword;
